(function (ws) {
    'use strict';

    ws.models.shippingCountry = Backbone.Model.extend({
        urlRoot: function() {
            if (isQuotingSite || isOrderEntrySite) {
                return globals.path.api.quoting.getCountryData.replace('{quoteId}', !_.isEmpty(this.get('quoteId')) ? '/' + this.get('quoteId') : '');
            } else {
                return globals.path.api.westcon.getCountryData.replace('{quoteId}', !_.isEmpty(this.get('quoteId')) ? '/' + this.get('quoteId') : '');
            }
        },

        /**
         * Get Country
         * @param {string} country
         */
        getCountry: function (country) {
            return _.findWhere(this.toJSON(), {
                isocode: country
            });
        }

    });
})(westcon);
